import React from 'react'

// Candidate components
import CandidateInterviewsList from "./CandidateInterviewsList"

export default function CandidateInterviews({ candidate = {} }) {
  return ( 
   	<div> <CandidateInterviewsList candidate={candidate}/> </div>
  )
}